import { render, staticRenderFns } from "./AgregarSeccionModal.vue?vue&type=template&id=079eb96a"
import script from "./AgregarSeccionModal.vue?vue&type=script&lang=js"
export * from "./AgregarSeccionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports